export const MCR = 'https://mountainconditions.ca'
export const AVCAN = 'https://avalanche.ca'
export const PARKS_CANADA = 'https://www.pc.gc.ca'
export const MWF = AVCAN + '/weather'
export const MIN = AVCAN + '/mountain-information-network'
export const FORECASTS = AVCAN + '/forecasts'
export const TRIP_PLANNER = AVCAN + '/planning/trip-planner'
export const SKI_ROGERS_PASS = PARKS_CANADA + '/skirogerspass'
